import localeText from "../../../../locale";

import { useRef, useState, useEffect } from "react";
import TypeService from "../../../../service/TypeService";
import { Toast } from "primereact/toast";
import "./NewType.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { locale } from "../../../../utilities/locale/locale";
import { Dropdown } from "primereact/dropdown";
import SubcategoriesService from "../../../../service/SubcategoriesService";

const NewType = (props) => {
  const typeService = new TypeService();
  const subcategoriesService = new SubcategoriesService();

  const toast = useRef(null);

  const [descriptionEN, setDescriptionEN] = useState(props?.isEdit ? props?.descriptionEN : "");
  const [descriptionES, setDescriptionES] = useState(props?.isEdit ? props?.descriptionES : "");
  const [descriptionIT, setDescriptionIT] = useState(props?.isEdit ? props?.descriptionIT : "");
  const [descriptionPT, setDescriptionPT] = useState(props?.isEdit ? props?.descriptionPT : "");

  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const [loadingRegister, setLoadingRegister] = useState(false);

  //  Get all brands and return the id of an specific brand
  const getTypeById = async (selectedType) => {
    const { result } = await typeService.getType(localStorage.getItem("__extraconomy_token"));

    const type = result.filter((type) => type.descriptionEnglish === selectedType);

    const { id } = type[0];

    return id;
  };

  const asyncLinkSubCategories = async (idbrand) => {
    const promises = selectedSubCategories.map(
      async (selectedSubCategory) => await linkTypeSubcategory(idbrand, selectedSubCategory.id)
    );

    await Promise.all(promises);
  };

  async function linkTypeSubcategory(idtype, idsubcategory) {
    try {
      setLoadingRegister(true);

      const res = await subcategoriesService.postLinkTypeSubcategory(
        localStorage.getItem("__extraconomy_token"),
        idtype,
        idsubcategory
      );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingRegister(false);
        if (res.messageCode === 500000) console.log(res);
        return;
      }
      if (res.messageCode === 200000) {
        if (res.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          setLoadingRegister(false);
          return;
        }
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingRegister(false);
        return;
      }
    } catch (e) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("unexpectedErrorRegisterProduct"),
        life: 6000,
      });
      setLoadingRegister(false);
      console.log(e);
    }
  }

  async function registerType() {
    if (selectedSubCategories.length === 0 && !props.isEdit) {
      toast.current.show({
        severity: "error",
        summary: localeText("chooseSubcategory"),
      });

      return;
    }

    try {
      setLoadingRegister(true);

      let res;

      if (!props?.isEdit)
        res = await typeService.postRegisterType(
          localStorage.getItem("__extraconomy_token"),
          descriptionEN,
          descriptionIT,
          descriptionPT,
          descriptionES
        );
      else
        res = await typeService.postEditType(
          localStorage.getItem("__extraconomy_token"),
          descriptionEN,
          descriptionIT,
          descriptionPT,
          descriptionES,
          props.id
        );

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingRegister(false);
        if (res.messageCode === 500000) console.log(res);
        return;
      }
      if (res.messageCode === 200000) {
        const idtype = await getTypeById(descriptionEN);

        await asyncLinkSubCategories(idtype);

        window.location.href = "/listtypes";
        if (res.messageCode !== 200000) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          setLoadingRegister(false);
          return;
        }
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoadingRegister(false);
        return;
      }
    } catch (e) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("unexpectedErrorRegisterProduct"),
        life: 6000,
      });
      setLoadingRegister(false);
      console.log(e);
    }
  }

  const createSubCategoryList = async () => {
    const { result } = await subcategoriesService.getSubcategories(
      localStorage.getItem("__extraconomy_token")
    );

    const editedCategories = result.map((oldFormatCategory) => {
      const {
        id,
        descriptionEnglish,
        descriptionSpanish,
        descriptionItalian,
        descriptionPortuguese,
      } = oldFormatCategory;

      let description = "";

      switch (locale) {
        case "pt":
          description = descriptionPortuguese;
          break;
        case "it":
          description = descriptionItalian;
          break;
        case "es":
          description = descriptionSpanish;
          break;
        default:
          description = descriptionEnglish;
          break;
      }

      return { label: description, id };
    });

    const listedCategories = [...editedCategories];

    setSubCategories(listedCategories);
  };

  useEffect(() => {
    createSubCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Toast ref={toast} />
      <div className="border-round" style={{ backgroundColor: "#46a748" }}>
        <h1 className="py-6 text-center text-0 lg:text-6xl md:text-6xl text-4xl">
          {props.isEdit ? localeText("edit") : localeText("addNewType")}
        </h1>
      </div>
      <div className="card border-1 border-300">
        <div className="mb-4">
          <h3 className="my-4">{localeText("typeInfo")}</h3>
          <p className="text-600">{localeText("typeFields")}</p>
          <div className="grid mt-6">
            <div className="col-12">
              <label htmlFor="descriptionTypeEN">{localeText("descriptionTypeEN")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionTypeEN"
                value={descriptionEN ? descriptionEN : ""}
                onChange={(e) => setDescriptionEN(e.target.value)}
              />
              <label htmlFor="descriptionTypeES">{localeText("descriptionTypeES")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionTypeES"
                value={descriptionES ? descriptionES : ""}
                onChange={(e) => setDescriptionES(e.target.value)}
              />
              <label htmlFor="descriptionTypeIT">{localeText("descriptionTypeIT")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionTypeIT"
                value={descriptionIT ? descriptionIT : ""}
                onChange={(e) => setDescriptionIT(e.target.value)}
              />
              <label htmlFor="descriptionTypePT">{localeText("descriptionTypePT")}</label>
              <InputText
                className="w-full my-2"
                name="descriptionTypePT"
                value={descriptionPT ? descriptionPT : ""}
                onChange={(e) => setDescriptionPT(e.target.value)}
              />
              {!props?.isEdit && (
                <>
                  <label>{localeText("subcategory")}</label>
                  <Dropdown
                    className="text-center w-full my-2"
                    value={selectedSubCategories[selectedSubCategories.length - 1]}
                    options={subCategories}
                    onChange={(e) => {
                      setSelectedSubCategories((oldState) => {
                        if (!oldState.includes(e.value)) return [...oldState.push(e.value)];

                        return [...oldState];
                      });
                    }}
                    style={{ minWidth: "108px" }}
                  />
                </>
              )}
              <ul
                className="list-none my-4 p-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                {selectedSubCategories.map((listedCategory) => (
                  <li
                    className="border-2 border-400 mt-4 mx-2 p-2"
                    style={{ borderRadius: "4em" }}
                    key={listedCategory.id}
                  >
                    {listedCategory.label}{" "}
                    <span
                      className="mx-2 cursor-pointer"
                      style={{ fontWeight: "bold" }}
                      onClick={() =>
                        setSelectedSubCategories((oldState) => {
                          return oldState.filter((element) => element !== listedCategory);
                        })
                      }
                    >
                      X
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="d-flex align-items-end flex-column">
              <Button
                label={localeText("registerType")}
                loading={loadingRegister}
                className="mr-2 w-full lg:w-auto md:w-auto m-1"
                onClick={() => registerType(true)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewType;
